import React, { useRef } from 'react';

import EmailEditor, { } from 'react-email-editor';

const App = (props) => {
  const emailEditorRef = useRef(null);

  const exportHtml = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml((data) => {
      const { html } = data;
      console.log('exportHtml', html);
    });
  };

  const onReady= (unlayer) => {

  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div style={{position: 'fixed'}}>
        <button onClick={exportHtml}>Export HTML</button>
      </div>

      <EmailEditor style={{height: '100vh'}} ref={emailEditorRef} onReady={onReady} />
    </div>
  );
};

export default App;